import React, {useState} from 'react';
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import {InputText} from "primereact/inputtext";
import {useTranslate} from "../../../system/useTranslate";
import {useSelector} from "react-redux";
import {DataView} from "primereact/dataview";
import Avatar from "../../../system/components/avatar";
import {Button} from "primereact/button";
import {Checkbox} from "primereact/checkbox";
import {useMountEffect} from "primereact/hooks";
import {copyToClipboard, mi} from "../../../system/utils";
import Icon from "../../../system/components/icon";
import DatatableEmptyMessage from "../../../system/components/datatable-empty-message";
function SelectIcon({value, onChange}) {
    const [searchText, setSearchText] = useState("");
    const translate = useTranslate();

    const ItemTemplate = (data)=>{
        return(
            <div onClick={()=>{onChange?.(`mi mi:${data}`)}} className="cursor-pointer h-fit flex flex-column"><Icon icon={`mi mi:${data}`} className="text-3xl"/><span className="text-2xs"></span></div>
        )
    }

    return (
        <div className="w-full flex flex-column gap-2 ">
            <div className="border-bottom-1 border-100">
                <IconField dir="rtl">
                    <InputIcon className="pi pi-search"/>
                    <InputText className="w-full text-xs py-2" placeholder={translate("search-icons-placeholder")} value={searchText} onChange={(e)=>{setSearchText(e.target.value)}}/>
                </IconField>
            </div>
            <div className="h-16rem w-20rem overflow-auto">
                <DataView emptyMessage={<DatatableEmptyMessage/>} layout="grid" className="h-full" itemTemplate={ItemTemplate} value={mi.filter(e=>e.includes(searchText))}/>

            </div>
        </div>
    );
}

export default SelectIcon;